module.exports = __webpack_public_path__ + "static/media/hamburger_icon-KO.81c06ca8.svg";